module.exports = __webpack_public_path__ + "fa-solid-900.1dc5b6dd4bf409a6f919.woff2";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-solid-900.woff2
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-solid-900.woff2
// module chunks = styles